import React, { useContext, useState } from "react";
import { Box, Button, Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Tabs,
  Tab,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@material-ui/core";

import videoImage from "images/videoCard.jpg";
import inProgress from "images/progress.jpg";
import done from "images/done.jpg";
import noData from "images/no-data.jpg";

import { AppContext } from "../../context/AppContext";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    marginTop: 10,
    marginBottom: 20,
    // maxHeight: 300,
    position: "relative",
  },
  media: {
    height: 140,
  },
  leftButton: {
    marginRight: theme.spacing(1),
  },
  rightButton: {
    marginLeft: theme.spacing(1),
  },
  title: {
    textTransform: "capitalize",
    fontSize: "large",
  },
  content: {
    fontSize: 15,
    color: "#8f8f8fe6",
    marginTop: 5,
  },
  submit: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: 10,
  },
  noDataCard: {
    width: "100%",
    height: 550,
    marginTop: 20,
  },
  ribbon: {
    left: "0rem",
    position: "absolute",
    top: "2rem",
    height: "1.5rem",
    width: "9rem",
    transform: "translate(-38px, -8px) rotate(-45deg)",
    backgroundColor: "#3366FF",
    textAlign: "center",
    color: "#fff",
    fontSize: 11,
    paddingTop: 2,
  },
}));

function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && children}
    </div>
  );
}

function TabView({
  liveRowData,
  rowData,
  handleButtonClick,
  handelResume,
}: any) {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const { batches, branches } = useContext(AppContext);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div>
      <Tabs value={value} onChange={handleChange}>
        <Tab label="Live" id="tab-0" aria-controls="tabpanel-0" />
        <Tab label="Completed" id="tab-1" aria-controls="tabpanel-1" />
      </Tabs>
      <TabPanel value={value} index={0}>
        {liveRowData?.length === 0 && (
          <Card className={classes.noDataCard}>
            <Box display="flex" justifyContent="center">
              <img src={noData} alt="noData" width="550px"></img>
            </Box>
          </Card>
        )}
        <Grid container spacing={2}>
          {liveRowData?.map((el: any, i: number) => (
            <Grid item xs={12} sm={6} md={4}>
              <Card className={classes.card}>
                <Box className={classes.ribbon}>
                  <span>
                    {
                      branches?.find(
                        (data: any) => data?.branchId === el?.branchId
                      )?.branchName
                    }
                  </span>
                </Box>
                <Grid item xs={12}>
                  <img
                  
                    src={el?.status === "In Progress" ? inProgress : videoImage}
                    alt="classViewImage"
                    width="100%"
                  ></img>
                 
                </Grid>
                <Grid item xs={12}>
                  <CardContent>
                    <Box>
                      <Typography variant="h5" className={classes.title}>
                        Name : {el?.title}
                      </Typography>
                      <Typography variant="h6" className={classes.content}>
                        Batch :{" "}
                        {
                          batches?.find(
                            (data: any) => data?.batchId === el?.batchId
                          )?.batch
                        }
                      </Typography>
                      <Typography variant="h6" className={classes.content}>
                        Faculty Name : {el?.facultyName}
                      </Typography>
                      <Typography variant="h6" className={classes.content}>
                        Subject : {el?.subject}
                      </Typography>
                      <Typography variant="h6" className={classes.content}>
                        Topic : {el?.topic}
                      </Typography>
                      <Typography variant="h6" className={classes.content}>
                        Date : {el?.scheduledDate}
                      </Typography>
                      <Typography variant="h6" className={classes.content}>
                        Time : {el?.scheduledTime}
                      </Typography>
                      <Box display="flex" style={{ marginTop: 10 }}>
                        <Typography
                          variant="h6"
                          className={classes.content}
                          style={{ marginRight: 10 }}
                        >
                          Status :
                        </Typography>
                        {el?.status === "In Progress" ? (
                          <Chip label={el?.status} color="secondary" />
                        ) : (
                          <Chip label={el?.status} color="primary" />
                        )}
                      </Box>
                    </Box>
                    <Box className={classes.submit}>
                      {el?.status === "In Progress" && (
                        <Button
                          variant="contained"
                          color="secondary"
                          className={classes.leftButton}
                          onClick={() => handelResume(el)}
                        >
                          Resume
                        </Button>
                      )}

                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.leftButton}
                        onClick={() => handleButtonClick(el)}
                      >
                        {el?.status === "In Progress"
                          ? "Complete"
                          : "Start Class"}
                      </Button>
                    </Box>
                  </CardContent>
                </Grid>
              </Card>
            </Grid>
          ))}
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        {rowData?.length === 0 && (
          <Card className={classes.noDataCard}>
            <Box display="flex" justifyContent="center">
              <img src={noData} alt="noData" width="550px"></img>
            </Box>
          </Card>
        )}
        <Grid container spacing={2}>
          {rowData?.map((el: any, i: number) => (
            <Grid item xs={12} sm={6} md={4}>
              <Card className={classes.card}>
                <Box className={classes.ribbon}>
                  <span>
                    {
                      branches?.find(
                        (data: any) => data?.branchId === el?.branchId
                      )?.branchName
                    }
                  </span>
                </Box>
                <Grid item xs={12}>
                  <img src={done} alt="classViewImage" width="100%" ></img>
                </Grid>
                <Grid item xs={12}>
                  <CardContent>
                    <Box>
                      <Typography variant="h5" className={classes.title}>
                        Class Name : {el?.title}
                      </Typography>
                      <Typography variant="h6" className={classes.content}>
                        Batch :{" "}
                        {
                          batches?.find(
                            (data: any) => data?.batchId === el?.batchId
                          )?.batch
                        }
                      </Typography>
                      <Typography variant="h6" className={classes.content}>
                        Faculty Name : {el?.facultyName}
                      </Typography>
                      <Typography variant="h6" className={classes.content}>
                        Subject : {el?.subject}
                      </Typography>
                      <Typography variant="h6" className={classes.content}>
                        Topic : {el?.topic}
                      </Typography>
                      <Box display="flex" style={{ marginTop: 10 }}>
                        <Typography
                          variant="h6"
                          className={classes.content}
                          style={{ marginRight: 10 }}
                        >
                          Status :
                        </Typography>
                        {el?.status === "In Progress" ? (
                          <Chip label={el?.status} color="secondary" />
                        ) : (
                          <Chip label={el?.status} color="primary" />
                        )}
                      </Box>
                    </Box>
                  </CardContent>
                </Grid>
              </Card>
            </Grid>
          ))}
        </Grid>
      </TabPanel>
    </div>
  );
}

export default TabView;
